import { Skeleton } from '@andritzot/metris-web-ui/feedback/skeleton';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

const CardSkeleton = () => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'grey.300',
      borderRadius: '4px',
      margin: '0px 5px 20px 15px',
      width: '295px',
      p: 2,
    }}
  >
    <Box sx={{ display: 'flex', mb: 0.5 }}>
      <Skeleton width="100%" height="4rem" />
    </Box>
    <Box sx={{ mb: 0.25 }}>
      <Skeleton width="100%" height="1rem" sx={{ mb: 0.25 }} />
      <Skeleton width="100%" height="1rem" sx={{ mb: 0.25 }} />
    </Box>
    <Skeleton width="100%" height="200px" />
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
      <Skeleton width="5rem" height="3rem" />
    </Box>
  </Box>
);

export default CardSkeleton;
